module.exports = __webpack_public_path__ + "img/a89f3fd.png";